import { ReactElement } from 'react';
import { DataPointWithValue } from '@src/types/DataPoint';
import ValueLoader from '@components/_shared/ValueLoader';
import { deviceDataPointsSectionStyles } from './DeviceDataPointsSection.styles';

type DeviceDataPointsSectionProps = {
  translateXCoordinate: number;
  translateYCoordinate: number;
  deviceDataPoints: DataPointWithValue[] | undefined;
  label: string;
};

function DeviceDataPointsSection(
  props: DeviceDataPointsSectionProps,
): ReactElement {
  const {
    translateXCoordinate,
    translateYCoordinate,
    deviceDataPoints,
    label,
  } = props;

  const { svgText, valueContainer, rect, foreignObject, layout } =
    deviceDataPointsSectionStyles;

  return (
    <g>
      <text
        x={translateXCoordinate}
        y={translateYCoordinate + layout.labelYOffset}
        {...svgText}
      >
        <tspan x={translateXCoordinate} dy={0}>
          {label}
          <br />
        </tspan>
      </text>

      <rect
        x={translateXCoordinate - layout.rectPadding}
        y={translateYCoordinate - layout.rowSpacing}
        width={layout.rectWidth}
        height={
          (deviceDataPoints?.length || 0) * layout.rowSpacing +
          layout.rectBottomPadding
        }
        {...rect}
      />

      <text x={translateXCoordinate} y={translateYCoordinate} {...svgText}>
        {deviceDataPoints?.map(
          (dataPoint: DataPointWithValue, index: number) => (
            <tspan
              key={`label-${index}`}
              x={translateXCoordinate}
              dy={index === 0 ? 0 : layout.rowSpacing}
            >
              {`${dataPoint.displayName}:`}
            </tspan>
          ),
        )}
      </text>

      {deviceDataPoints?.map((dataPoint: DataPointWithValue, index: number) => (
        <foreignObject
          key={`value-${index}`}
          x={translateXCoordinate + foreignObject.xOffset}
          y={
            translateYCoordinate +
            foreignObject.yOffset +
            index * foreignObject.rowHeight
          }
          width={foreignObject.valueWidth}
          height={foreignObject.valueHeight}
        >
          <div style={valueContainer}>
            <ValueLoader dataPoint={dataPoint} />
          </div>
        </foreignObject>
      ))}
    </g>
  );
}

export default DeviceDataPointsSection;
